import WithBusinessUnitsDataFetching from 'ui-business-units-lib/utils/WithBusinessUnitsDataFetching';
import BusinessUnitTag from 'ui-business-units-lib/components/BusinessUnitTag';
import { useSelector } from 'react-redux';
// @ts-expect-error not migrated to TS yet
import { hasAccessToBusinessUnit } from 'EmailData/selectors/user';
import PropTypes from 'prop-types';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { BusinessUnitsRebrandMessage } from 'ui-business-units-lib/components/BusinessUnitsRebrandMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const BusinessUnitTagWithDataFetching = WithBusinessUnitsDataFetching(({
  buId,
  buOptions = [],
  className = '',
  noBorder = false,
  onlyName = false
}) => {
  if (onlyName) {
    const emailBuOption = buOptions.find(({
      id
    }) => id === buId);
    const buName = emailBuOption ? emailBuOption.name : '';
    return /*#__PURE__*/_jsx("span", {
      className: className,
      children: buName
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: `flex-row justify-between ${className}`,
    children: /*#__PURE__*/_jsx(BusinessUnitTag, {
      buId: buId,
      buOptions: buOptions,
      noBorder: noBorder
    })
  });
});
function BusinessUnitLabel({
  buId,
  className = '',
  noBorder = false,
  onlyName = false,
  shouldShowBUTooltip = false
}) {
  const isVisible = useSelector(hasAccessToBusinessUnit);
  if (!isVisible) {
    return null;
  }
  return /*#__PURE__*/_jsx(UITooltip, {
    placement: "right",
    disabled: !shouldShowBUTooltip,
    title: /*#__PURE__*/_jsx(BusinessUnitsRebrandMessage, {
      message: "EmailComponents.buMigration.buTooltip",
      rebrandMessage: "EmailComponents.buMigration.buTooltip_buv2"
    }),
    children: /*#__PURE__*/_jsx("div", {
      className: "flex-row align-center",
      "data-test-id": "current-bu-tag",
      children: /*#__PURE__*/_jsx(BusinessUnitTagWithDataFetching, {
        className: className,
        buId: buId,
        noBorder: noBorder,
        onlyName: onlyName
      })
    })
  });
}
BusinessUnitTagWithDataFetching.propTypes = {
  buId: PropTypes.number.isRequired,
  buOptions: PropTypes.array.isRequired,
  className: PropTypes.string,
  noBorder: PropTypes.bool,
  onlyName: PropTypes.bool,
  shouldShowBUTooltip: PropTypes.bool
};
BusinessUnitLabel.propTypes = {
  buId: PropTypes.number.isRequired,
  className: PropTypes.string,
  noBorder: PropTypes.bool,
  onlyName: PropTypes.bool,
  shouldShowBUTooltip: PropTypes.bool
};
export default BusinessUnitLabel;